export default __webpack_public_path__ + "static/media/Message.fe6600b0.wav";